import React from 'react';
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types';
import {
  FormGroup,
  InputGroup,
  Button,
  ButtonToolbar,
  ControlLabel,
  FormControl,
  HelpBlock,
  Image,
  Carousel,
  Table

} from 'react-bootstrap';
import { Form, Field } from 'react-final-form';
import { required, number, positiveNumber } from '../../../forms';
import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import { left, center, right, justify, Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import Layout from '../../../components/Layout/Layout';
import Select from 'react-select';
import noimage1 from '../../../../public/noimage1.jpg'
import moment from 'moment';
import diff from 'object-diff';

const Error = ({ name }) => (
  <Field
    name={name}
    subscription={{ touched: true, error: true }}
    render={({ meta: { touched, error } }) =>
      touched && error ? <span className="alert-danger">{error}</span> : null
    }
  />
);
export const requiredField = value => (value ? undefined : <span className="alert-danger">Required</span>);
export const renderTextField = ({ input, label, type, placeholder, meta: { touched, error, warning } }) => (
  <InputGroup>
    {label && (<ControlLabel>{label}</ControlLabel>)}
    <FormControl
      {...input}
      type={type}
      label={label}
      placeholder={placeholder}
    />
    {touched &&
      ((error && <p className="alert alert-danger">{error}</p>) ||
        (warning && <p className="alert alert-warning">{warning}</p>))}
  </InputGroup>
);
  const RenderSelectInput = ({
  input,
  options,
  name,
  id,
  label,
  help,
  meta: { active, touched, error, warning },
}) => (
    <FormGroup>
      <ControlLabel>{label}</ControlLabel>
      <Select
        id={id}
        name={name}
        options={options}
        value={input.value}
        onChange={value => {
          input.onChange(value.value);
        }}
        onBlur={value => input.onBlur(value.value)}
        joinValues
      />
      {help && <HelpBlock>{help}</HelpBlock>}
      {touched &&
        ((error && <p className="alert alert-danger">{error}</p>) ||
          (warning && <p className="alert alert-warning">{warning}</p>))}
    </FormGroup>
  );

function getInitialEditorState(content) {
  if (!content) {
    return EditorState.createEmpty();
  }
  if (Object.keys(content).length === 0 && content.constructor === Object) {
    return EditorState.createEmpty();
  }
  return EditorState.createWithContent(convertFromRaw(content));
}

const StatusOptions = [
  {
    label: 'Open',
    value: '2'
  },
  {
    label: 'Pending',
    value: '3'
  },
  {
    label: 'Resolved',
    value: '4'
  },
  {
    label: 'Closed',
    value: '5'
  }
]

const PriorityOptions = [
  {
    label: 'Low',
    value: '1'
  },
  {
    label: 'Medium',
    value: '2'
  },
  {
    label: 'High',
    value: '3'
  },
  {
    label: 'Urgent',
    value: '4'
  }
]

function hasPhotos(photos) {
  if (!photos) {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(photos, 'length')) {
    return photos.length !== 0;
  }
  return false;
}

function formatCarouselPhotos(photos) {
  const photoList = [];
  if (hasPhotos(photos)) {
    photos.forEach(photo => {
      photoList.push(
        <Carousel.Item key={photo.id}>
          {photo.attachment_url ?
            <Image src={photo.attachment_url} responsive className="hotel-img" />
            :
            <Image src={noimage1} responsive className="hotel-img" />
          }
        </Carousel.Item>
      );
    });
  } else {
    photoList.push(
      <Carousel.Item key={1}>
        <Image src={noimage1} responsive className="hotel-img" />
      </Carousel.Item>
    );
  }
  return photoList
}

class TicketDetailView extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handlegetPhoto = this.handlegetPhoto.bind(this);
    this.editimage = this.editimage.bind(this);
    //this.handleSubmit = this.handleSubmit.bind(this);
    const editorState = getInitialEditorState();

    this.state = {
      editorState,
      pristine: true,
      editorData: { value: "" },
      photos: "",
      show: false,
      data: [],
      Comments: [],
      OpenCarouselModal: false
    };
  }

  editimage() {
    //this.setState({ isImageEdit: false })
  }
  onSubmit = (values) => {
    let data = {
      comment: values.comment,
      id:this.props.ticket_id
    }
    this.props.addComment(data)
    this.props.onClose();
  }

  handleClose() {
    const editorState = getInitialEditorState();
    this.setState({ show: false, editorState, editorData: { value: '' } });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handlegetPhoto(values) {
    this.setState({ photos: values.photo.preview });
  }

  onClose = () => {
    this.props.onClose();
  }
  onCarouselModalClose = () => {
    this.setState({
      OpenCarouselModal: false,
    })
  }

  componentDidMount() {
    const payload = {id:this.props.ticket_id}
    this.props.requestTicket(payload,(response) => {
      this.props.requestComments(payload,(response_comment) => {
        this.setState({ data: (typeof(response.ticket) != 'undefined') ? response.ticket : [], Comments: (typeof(response_comment.Comments) != 'undefined') ? response_comment.Comments : [] })
      })  
    })

  }

  openViewModal = idx => {
    this.setState({
      OpenCarouselModal: true,
    })
  };

  formatRoomTypesView = (roomtypes) => {
    if (roomtypes && roomtypes.length) {
      const roomsList = [];
    roomtypes.forEach(room => {
      roomsList.push(
        <div className="col-md-3" key={room.id}>
          <div className="thumbnail" onClick={() => this.openViewModal(room.id)} >
            {hasPhotos(roomtypes) ? <Image src={room.attachment_url} responsive className="hotel-img" /> : <Image src={noimage1} responsive className="hotel-img" />}
          <div>
              {/* <h4>{room.name}</h4> */}
            </div>
          </div>
        </div>
      )
    })
    return roomsList
  }
  return (
    <div className="col-md-12">
      <h5 className="hotel-highlight">No attachments available</h5>
    </div>
  )
  }
  

  render() {
    //const payload = {id:this.props.ticket_id}
    //const ticket_details = this.props.requestTicket(payload)
    const errors = {};
    const auth = JSON.parse(sessionStorage.getItem('auth'));
    const email = auth.profile.user.email;
    const Name = auth.profile.user.first_name + ' ' + auth.profile.user.last_name;
    let ticket_details = this.state.data
    let ticket_comments = []
    this.state.Comments.forEach(comment => {
      let cmnt = comment.body_text
      ticket_comments.push(<div><b>{Name}</b> <br/> &nbsp;&nbsp;&nbsp;{cmnt}</div>)  
      //ticket_comments.push(<div>{cmnt} - <b>Added By</b> {Name}</div>)
    })
    const ticket_status = ticket_details.status ? ticket_details.status == 2 ? 'Open' : ticket_details.status == 3 ? 'Pending' : ticket_details.status == 4 ? 'Resolved' : ticket_details.status == 5 ? 'Closed' : 'N/A' : 'N/A';
    const ticket_priority = ticket_details.priority ? ticket_details.priority == 1 ? 'Low' : ticket_details.priority == 2 ? 'Medium' : ticket_details.priority == 3 ? 'High' : ticket_details.priority == 4 ? 'Urgent' : 'N/A' : 'N/A';
    const ticket_source = ticket_details.source ? ticket_details.source == 1 ? 'Email' : ticket_details.source == 2 ? 'Portal' : ticket_details.source == 3 ? 'Phone' : ticket_details.source == 7 ? 'Chat' : ticket_details.source == 8 ? 'Mobihelp' : ticket_details.source == 9 ? 'Feedback Widget' : ticket_details.source == 10 ? 'Outbound Email' : 'N/A' : 'N/A';
    let attachment_list = this.formatRoomTypesView(ticket_details.attachments)
    const photos = formatCarouselPhotos(ticket_details.attachments);
    const mobile = auth.profile.mobile
    //let ticket_details = this.props.tickets.find(itm => itm.id == this.props.ticket_id ? itm : '')    

    return (
        <div>
        <Modal show={this.props.show} onHide={this.onClose} bsSize="large">
            <Modal.Header closeButton>
              <Modal.Title>Ticket Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div>
            <div><h4>Ticket Details</h4></div>
              <div className="row">
                <div className="col-md-6">
                  <p><b>Req ID</b>: {ticket_details.id}</p>
                  <p><b>Name</b>: {Name}</p>
                  <p><b>Email</b>: {email}</p>
                </div>
                <div className="col-md-6">
                  {/* <p>Type: {ticket_details.type}</p> */}
                  {/* <p>Priority: {ticket_priority}</p> */}
                  {/* <p>Source: {ticket_source}</p> */}
                  <p><b>Phone</b>: {mobile}</p>
                  <p><b>Status</b>: {ticket_status}</p>
                </div>
              </div>
              <div className="row"></div>
              <div style={{marginTop: '20px'}}>
                <p><b>Subject:</b> {ticket_details.subject}</p>
              </div>
              <div>
                <p><b>Description:</b> {ticket_details.description_text}</p>
              </div>
              <div style={{marginTop:'35px'}}><h4>Attachments</h4>
                <div className="row">{attachment_list}</div>   
              </div>
              <br></br>
              <div><h4>Comments</h4></div>
              <div style={{marginTop:'25px'}}>{ticket_comments}</div>
              <div>

              <br/>
              <Form
                onSubmit={this.onSubmit}
                initialValues={{name: Name,email:email,phone:mobile}}
                render={({ handleSubmit, pristine, invalid,Name,initialValues }) => (
                  <form onSubmit={handleSubmit} >
                    <div>
                      <div>
                        <FormGroup>
                          <Field
                            name="comment"
                            type="text"
                            component={renderTextField}
                            label=""
                            placeholder="Leave a Reply"
                            bsClass="hotel-highlight"
                            validate={requiredField}
                          />
                        </FormGroup>  
                      </div>
                      {errors !== undefined && errors.FORM_ERROR && (
                        <p className="alert alert-danger">{errors.FORM_ERROR}</p>
                      )}
                      {errors !== undefined && errors.note && (
                        <p className="alert alert-danger">{errors.note}</p>
                      )}
                      <FormGroup>
                        <ButtonToolbar  style={{ float: 'right' }}>
                          <Button disabled={false} bsStyle="success" type="submit">
                            Post
                          </Button>
                        </ButtonToolbar>
                      </FormGroup>
                    </div>
                  </form>
                )}
              /> 
              </div>
              {/* <ButtonToolbar style={{ float: 'right' }}>
                <Button bsStyle="success" onClick={this.onClose}>Ok</Button>
              </ButtonToolbar> */}
            </div>  
            </Modal.Body>
            <Modal.Footer style={{ clear: 'both' }} />
          </Modal>

        {this.state.OpenCarouselModal && (
          <Modal show={this.state.OpenCarouselModal} onHide={this.onCarouselModalClose} bsSize="large">
            <Modal.Header closeButton>
              <Modal.Title>Ticket Attachments</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            <div><Carousel
                  indicators={true}
                  interval={null}
                  prevIcon={<i className="fa fa-chevron-left hotel-carousel-control left" />}
                  nextIcon={<i className="fa fa-chevron-right hotel-carousel-control right" />}
                  onSelect={this.editimage}
                >
                  {photos}
                </Carousel>
              </div> 
           </Modal.Body>
           <Modal.Footer style={{ clear: 'both' }} />
         </Modal>          )
        }
      </div>  
    );
  }
}



export default TicketDetailView;
  //render(<Example />);


// WEBPACK FOOTER //
// src/routes/support/components/TicketDetailView.js